
export const APIENDPOINTURL = {
   ReceivingApi:{
    GetInvoice: '/api/MerchandiseArrival/GetSavedInvoice',
    GetInvoiceDetails: '/api/MerchandiseArrival/GetSavedInvoiceDetails',
    GetPOSummary: '/api/PurchaseOrder/GetPOSummary',
    GetPoDetails: '/api/MerchandiseArrival/GetPoDetails',
    GetInventoryLookup: '/api/Inventory/GetInventoryLookup',
    GetSupplierList: '/api/Setup/SearchSuppliers',
    GetLocationList: '/api/Setup/Locations',
    PostReceivingMA: '/api/MerchandiseArrival/PostMA',
    SaveReceivingMA: '/api/MerchandiseArrival/SaveMA',
    DeleteSavedInvoice: '/inventory/api/DeleteSavedInvoice'
   },
}

export enum UnitTypeId {
   BaseUnit = 0,
   PurchaseUnit = 1,
   TransactionUnit = 2,
   RecipeUnit = 3,
   BatchSizeUnit = 4,
   PortionsUnit = 5,
   SalesUnit = 6
 }

export const SETTINGCONFIG = {
   Settings: {
    AdditemSearchKey: 3,
    LoggedInSiteId: null
   },
   Keys: {
    Detail: 'detail',
    PoLoad: 'poloaded',
    Confirm: 'confirm',
    Warning: 'Warning',
    Info: 'Info',
    PartiallySuccess: 'partialsuccess',
    Success: 'Success',
    Post: 'post',
    Save: 'save',
    PostContinue: 'postcontinue',
    PartialBackOrderSuccess: 1,
    PartialBackOrderCancel: 2,
    Cancel: 'cancel',
    savedreceiving: 'savedreceiving',
    delete: 'deletemessage',
    preview: 'preview',

   },
   Formats: {
      dateFormate: 'MM/DD/YYYY',
      currencyFormate: '0.0000',
      CurrencyCode: 'USD',
      decimalFormat: '0.0000'      
   },
   Language: {
      en: 'enR',
      fr: 'frR'
   }
}

export const APPLICATION = {
   eatec: 'eatec',
   sws: 'sws'
}

export const POPDIALOG = {
   ContentWidth: '90vw'
}
export enum PREVILEGEKEY {
   GetSavedInvoice = 'GetSavedInvoice',
   GetSavedInvoiceDetails = 'GetSavedInvoiceDetails',
   DeleteSavedInvoice = 'DeleteSavedInvoice',
   PostMa = 'PostMa',
   SaveMa = 'SaveMa'
}
